module.exports = __webpack_public_path__ + "static/img/login_background_new.2bfc4366.png";